<template>
    <div class="px-2">
        <div class="zoezi-datepicker-buttons">
            <v-row>
                <v-col cols=6>
                    <zoezi-button @click="selectedDate = Date.today()" :text="$translate('Today')" block thin />
                </v-col>
                <v-col cols=6>
                    <zoezi-button @click="selectedDate = Date.today().addDays(7).monday()" :text="$translate('Next week')" block thin />
                </v-col>
            </v-row>
        </div>

        <div class="d-flex text-center my-2">
            <span class="z-1of8"><v-icon @click="prevMonth" v-if="canPrev">mdi-chevron-left</v-icon></span>
            <span class="z-6of8">{{monthName}} {{browsingDate.getFullYear()}}</span>
            <span class="x-1of8"><v-icon @click="nextMonth">mdi-chevron-right</v-icon></span>
        </div>

        <div class="d-flex text-center">
            <span class="z-1of8"></span>
            <span class="z-1of8" v-for="wd in weekdaysShort" :key="wd">
                {{wd}}
            </span>
        </div>

        <div class="d-flex text-right" v-for="week in weeks" :key="week.number">
            <span class="z-1of8 zoezi-datepicker-week">
                <v-btn rounded text :height="size" :width="size" @click="selectWeek(week)" :disabled="week.days[6].date < minDateComputed">
                    {{week.number}}
                </v-btn>
            </span>
            <span class="z-1of8 zoezi-datepicker-day"
                  v-for="day in week.days" :key="day.date.getTime()"
                  :class="{ 'zoezi-datepicker-day-outside-month': !day.samemonth, 'zoezi-datepicker-day-unpickable': !day.pickable}">
                <v-btn v-if="isDaySelected(day)" color="primary" class="primarytext--text" rounded :height="size" :width="size">{{day.date.getDate()}}</v-btn>
                <v-btn v-else rounded text :disabled="!day.pickable" :height="size" :width="size" @click="selectDay(day)">{{day.date.getDate()}}</v-btn>
            </span>
        </div>
    </div>
</template>

<script>
import ZoeziButton from '../views/Button.vue'
export default {
    name: 'zoezi-datepicker',

    zoezi: {
        title: 'Date picker',
        icon: 'mdi-calendar',
        internal: true
    },

    props: {
        value: {
            title: 'Selected date',
            type: String,
            fulltype: 'date',
            default: null
        },
        minDate: {
            title: 'First selectable date'
        },
        week: {
            title: 'Weekly mode',
            type: Boolean,
            default: false
        }
    },

    components: {
        ZoeziButton
    },

    watch: {
        value: {
            immediate: true,
            handler() {
                let date = Date.newFull(this.value) || Date.today();
                if (!Date.dateEquals(date, this.selectedDate)) {
                    this.selectedDate = date;
                }
            }
        },
        selectedDate: {
            immediate: true,
            handler(newValue, oldValue) {
                this.browsingDate = this.selectedDate;
                if (oldValue) {
                    this.$emit('input', this.selectedDate);
                    this.$emit('change');
                }
            }
        }
    },

    data: () => ({
        size: 32,
        selectedDate: null,
        browsingDate: null
    }),

    computed: {
        monthName() {
            return this.$translate(this.browsingDate?.getMonthName());
        },
        weekdaysShort() {
            return ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map(this.$translate).map(x => x.substring(0,2))
        },
        minDateComputed() {
            if (!this.minDate) {
                return Date.newFull('1900-01-01').clearTime();
            }

            return Date.newFull(this.minDate);
        },

        weeks() {
            let firstDay = this.browsingDate.firstDayThisMonth();
            let lastDay = this.browsingDate.lastDayThisMonth();
            let lastWeek = this.browsingDate.lastDayThisMonth().getWeekNumber();

            let res = [];
            let date = firstDay.monday().clone();
            while (!res.length || res[res.length-1].number != lastWeek) {
                let number = date.getWeekNumber();
                let days = [];
                while (date.getWeekNumber() == number) {
                    days.push({date: date.clone(), samemonth: date >= firstDay && date <= lastDay, pickable: date >= this.minDateComputed});
                    date.addDays(1)
                }
                res.push({number, days});
            }
            return res;
        },
        canPrev() {
            return this.browsingDate.firstDayThisMonth().clone().addDays(-1) >= this.minDateComputed;
        }
    },

    methods: {
        nextMonth() {
            this.browsingDate = this.browsingDate.clone().addMonths(1);
        },
        prevMonth() {
            this.browsingDate = this.browsingDate.clone().addMonths(-1);
        },
        selectWeek(week) {
            this.selectedDate = new Date(Math.max(this.minDateComputed, week.days[0].date));
        },
        selectDay(day) {
            if (this.week) {
                this.selectedDate = new Date(Math.max(this.minDateComputed, day.date.monday()));
            } else {
                this.selectedDate = day.date;
            }
        },
        isDaySelected(day) {
            if (this.week) {
                return day.date.getWeekNumber() == this.selectedDate.getWeekNumber() && day.date >= this.minDateComputed;
            } else {
                return Date.dateEqualsObjects(day.date, this.selectedDate);
            }
        }
    }
}
</script>
